<template>
  <section class="hero" id="home">
    <div class="hero-background">
      <div class="hero-overlay"></div>
    </div>
    
    
    <div class="container">
      <div class="hero-content">
        <!-- 移动端：hero-text在上方 -->
        <div class="hero-text">
          <div class="hero-badge">创新技术</div>
          <h1 class="hero-title">用创新技术塑造未来数字世界</h1>
          <p class="hero-description">
            我们致力于通过前沿的技术解决方案，为企业提供数字化转型的全方位支持，
            帮助客户在数字化浪潮中保持竞争优势，实现可持续发展。
          </p>
        </div>
        
        
        <!-- 移动端：hero-actions在下方 -->
        <div class="hero-actions">
          <button class="btn btn-primary btn-large">立即体验</button>
          <button class="btn btn-outline btn-large">了解更多</button>
        </div>
        
        <!-- <div class="hero-thumbnails">
          <div class="thumbnail" v-for="i in 6" :key="i"></div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style scoped>
.hero {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  color: white;
  overflow: hidden;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
              url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(60, 89, 255, 0.1), rgba(9, 214, 249, 0.1));
}



.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 5;
}

.hero-content {
  max-width: 600px;
}

.hero-badge {
  display: inline-block;
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 24px;
}

.hero-title {
  font-size: 3.5rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0 0 24px 0;
  color: white;
}

.hero-description {
  font-size: 1.125rem;
  line-height: 1.6;
  margin: 0 0 32px 0;
  color: rgba(255, 255, 255, 0.9);
}

.hero-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 48px;
}

.btn-primary {
  background: linear-gradient(135deg, #3C59FF, #09D6F9);
  color: white;
  border: none;
}

.btn-outline {
  background: transparent;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.hero-thumbnails {
  display: flex;
  gap: 12px;
}

.thumbnail {
  width: 60px;
  height: 40px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@media (max-width: 1200px) {
  .hero-content {
    max-width: 100%;
    margin-right: 0;
  }
}

@media (max-width: 1024px) {
  .hero-content {
    max-width: 100%;
    margin-right: 0;
  }
}

@media (max-width: 768px) {
  .hero {
    min-height: 100vh;
    padding: 60px 0 40px;
    text-align: center;
  }
  
  .container {
    padding: 0 24px;
    max-width: 100%;
    width: 100%;
  }
  
  .hero-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
  
  .hero-text {
    order: 1;
    text-align: center;
  }
  
  .hero-badge {
    font-size: 0.8rem;
    padding: 6px 12px;
    margin-bottom: 24px;
    display: inline-block;
  }
  
  .hero-title {
    font-size: 2rem;
    line-height: 1.2;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 700;
  }
  
  .hero-description {
    font-size: 1rem;
    line-height: 1.6;
    margin-bottom: 0;
    text-align: center;
    max-width: 100%;
    color: #6b7280;
  }
  
  
  .hero-actions {
    order: 3;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    margin: 0;
  }
  
  .btn {
    width: 100%;
    max-width: 280px;
    padding: 18px 32px;
    font-size: 1rem;
    border-radius: 12px;
    font-weight: 600;
  }
  
  .hero-thumbnails {
    display: none;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 50px 0 30px;
    min-height: 100vh;
  }
  
  .container {
    padding: 0 20px;
  }
  
  .hero-content {
    gap: 32px;
  }
  
  .hero-badge {
    font-size: 0.75rem;
    padding: 4px 10px;
    margin-bottom: 20px;
  }
  
  .hero-title {
    font-size: 1.75rem;
    line-height: 1.2;
    margin-bottom: 16px;
  }
  
  .hero-description {
    font-size: 0.95rem;
    line-height: 1.6;
    margin-bottom: 0;
  }
  
  
  .hero-actions {
    gap: 14px;
  }
  
  .btn {
    padding: 16px 28px;
    font-size: 0.95rem;
    max-width: 260px;
  }
}
</style>
